import React from 'react';
import PropTypes from 'prop-types';

const Wardrobe = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M18.325 19.64c0 .927-.597 1.68-1.332 1.68H7.006c-.735 0-1.332-.753-1.332-1.68V3.68c0-.926.597-1.68 1.332-1.68h9.987c.735 0 1.332.754 1.332 1.68v15.96Z"
      clipRule="evenodd"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.705 11.226v1.858m4.465-1.858v1.858m2.233 8.247V22m0-.669V22m-8.93-.669V22"
    />
    <path stroke={color} strokeLinejoin="round" d="M11.975 2v19.32" />
  </svg>
);

Wardrobe.propTypes = {
  color: PropTypes.string
};

export default Wardrobe;
